import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Injector,
  input,
  Input,
  type OnInit,
  Output,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SharedI18nModule } from '@bizzdesign/shared/i18n';
import { type BdAvatar } from '@bizzdesign/shared/utils';
import { ButtonModule } from 'primeng/button';
import { PopoverModule } from 'primeng/popover';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { TooltipModule } from 'primeng/tooltip';
import { PreventScrollDirective } from '@bizzdesign/shared/directives';
import { UserCardComponent } from '@bizzdesign/ui-user-card';
import { AvatarGroupComponent } from '@bizzdesign/ui-avatar-group';
import { AvatarGroupMenuComponentStore } from './avatar-group-menu.component.store';

@Component({
  selector: 'bd-avatar-group-menu',
  imports: [
    AvatarGroupComponent,
    ButtonModule,
    PopoverModule,
    ToggleSwitchModule,
    UserCardComponent,
    SharedI18nModule,
    FormsModule,
    TooltipModule,
    PreventScrollDirective,
  ],
  providers: [AvatarGroupMenuComponentStore],
  templateUrl: './avatar-group-menu.component.html',
  styleUrl: './avatar-group-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AvatarGroupMenuComponent implements OnInit {
  readonly avatarGroupMenuComponentStore = inject(
    AvatarGroupMenuComponentStore,
  );
  readonly #injector = inject(Injector);

  readonly avatars = input<BdAvatar[]>([]);

  @Input() areCursorsVisible = false;

  @Output() toggleCursorsVisibility = new EventEmitter<boolean>();

  ngOnInit(): void {
    this.avatarGroupMenuComponentStore.togglePopover(this.avatars, {
      injector: this.#injector,
    });
  }
}
